module.exports = __webpack_public_path__ + "img/PackageLimited.523faf9a.png";